










import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { PoiArExperience, Poi } from '@/models/poi';
import { urlize } from '@/utils';

@Component
export default class PoiSlideArExperience extends Vue {

    @Prop(Object) public model: PoiArExperience;
    @Prop(Object) public poi: Poi;
    @Prop({ type: Boolean, default: true }) public enabled: boolean;

    get imageUrl() {
        return urlize(this.model.preview.medium);
    }

    public onPlayClicked() {
        if (!this.enabled) return;

        this.$f7router.navigate(`/pois/${this.poi.id}/ar/`, {
            props: {
                model: this.model
            },
            animate: true,
        });

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'playAR',
            eventLabel: this.model.experience,
        });
    }
}
